import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import { blindShuffle } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import _ from 'lodash'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'
function CategorizeComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    screenMode
  } = props
  const {
    ControlID,
    Options,
    AnswerType,
    Score,
    AnswerColorFill,
    QuestionColorFill,
    AnswerFontSize,
    QuestionFontSize,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    FontStyle,
    Italic,
    Bold
  } = mcData

  const [droppedItems, setDroppedItems] = useState([])
  const [dragItems, setdragItems] = useState([])
  const [currentScore, setcurrentScore] = useState(0)
  const [currentAttempts, setCurrentAttempts] = useState(0)
  const [dragItem, setDragItem] = useState('')

  useEffect(() => {
    const localOptions = Options
    let allAnswers = []
    localOptions.map((option) => {
      option.Answers.map((answer) => {
        allAnswers.push(answer)
      })
    })

    let finalDroppedItemsCopy = []
    for (let index = 0; index < Options.length; index++) {
      finalDroppedItemsCopy.push(undefined)
    }

    if (defaultValue) {
      const { dragItems, droppedItems, currentAttempts } = defaultValue.CtlValue
      let defaultScore = defaultValue.CtlScore
      if (dragItems && droppedItems && currentAttempts) {
        setdragItems(dragItems)
        setDroppedItems(droppedItems)
        setCurrentAttempts(currentAttempts)
      } else {
        setdragItems(blindShuffle(allAnswers))
        let droppedItemCopy = []
        for (let index = 0; index < Options.length; index++) {
          droppedItemCopy.push([])
        }
        setDroppedItems(droppedItemCopy)
      }
      setcurrentScore(defaultScore)
    } else {
      setdragItems(blindShuffle(allAnswers))
      let droppedItemCopy = []
      for (let index = 0; index < Options.length; index++) {
        droppedItemCopy.push([])
      }
      setDroppedItems(droppedItemCopy)
      setCurrentAttempts(0)
      setcurrentScore(0)
    }
  }, [defaultValue])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(
        droppedItems,
        dragItems,
        currentAttempts,
        currentScore,
        true
      )
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick) {
      let isAligned = true
      for (let index = 0; index < Options.length; index++) {
        if (
          droppedItems[index] &&
          Options[index].Answers.length === droppedItems[index].length
        ) {
          for (let i = 0; i < droppedItems[index].length; i++) {
            const d = droppedItems[index][i]
            const isInRightPlace = Options[index].Answers.findIndex(
              (answer) => answer.Key === d.Key
            )
            if (isInRightPlace === -1) {
              isAligned = false
              break
            }
          }
        } else {
          isAligned = false
          break
        }
      }
      if (isAligned) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }, [explanationClick])

  function handleDroppedItems(index, dropedElements) {
    if (index !== '') {
      let droppedItemsCopy = [...droppedItems]
      droppedItemsCopy[parseInt(index)].push(dropedElements)
      const dragItemsCopy = dragItems.filter(
        (item) => item.Key !== dropedElements.Key
      )

      setdragItems(dragItemsCopy)
      setDroppedItems(droppedItemsCopy)

      let totalScore = 0
      let currentScore = 0
      let noOfCorrectAnswer = 0
      let totalAnswerCount = 0
      Options.forEach((o) => {
        totalScore += o.Question.Score
      })

      Options.forEach((o) => {
        o.Answers.forEach((a) => {
          if (!a.IsDecoy) {
            totalAnswerCount++
          }
        })
      })

      // (a/(greater of(b, d)))*c
      // a-no of correct answers
      // b-attemps
      // c- total score
      // d- total items in bin

      for (const key in droppedItemsCopy) {
        if (Object.prototype.hasOwnProperty.call(droppedItemsCopy, key)) {
          const withoutDecoy = Options[key].Answers.filter((o) => !o.IsDecoy)
          const answerWithoutDecoy = withoutDecoy.map((w) => w.Key)
          const elements = droppedItemsCopy[key]
          elements.forEach((element) => {
            if (answerWithoutDecoy.includes(element.Key)) {
              noOfCorrectAnswer++
            }
          })
        }
      }

      //new score calculation
      let currentAttemptsCopy = currentAttempts + 1
      setCurrentAttempts(currentAttemptsCopy)
      currentScore =
        (noOfCorrectAnswer / Math.max(currentAttemptsCopy, totalAnswerCount)) *
        totalScore
      setcurrentScore(currentScore)
      onAttemptChange(1)

      //Display currect 0r wrong icon
      if (isPractice) {
        const isInRightPlace = Options[parseInt(index)].Answers.findIndex(
          (answer) => answer.Key === dropedElements.Key && !answer.IsDecoy
        )
        if (isInRightPlace > -1) {
          handleSuccessChange(true)
        } else {
          handleSuccessChange(false)
        }
      }
      validateCorrectAnswer(
        droppedItemsCopy,
        dragItemsCopy,
        currentAttemptsCopy,
        currentScore,
        false
      )
    }
  }

  function onDragging(h) {
    setDragItem(h)
  }

  function allowDrop(ev) {
    ev.preventDefault()
  }

  function validateCorrectAnswer(
    droppedItemsCopy,
    dragItemsCopy,
    currentAttemptsCopy,
    currentScoreCopy,
    timerValue
  ) {
    onValueChange(
      ControlID,
      {
        dragItems: dragItemsCopy,
        droppedItems: droppedItemsCopy,
        currentAttempts: currentAttemptsCopy
      },
      currentScoreCopy,
      Score,
      '',
      timerValue
    )
  }

  return (
    <div className='slide-comp-wrapper'>
      {!isVerifyMode ? (
        <div className='categ-bin-container' id='bin-container'>
          {Options.map((option, index) => {
            let isAligned = true
            if (droppedItems[index]) {
              if (
                droppedItems[index].length === Options[index].Answers.length
              ) {
                for (let i = 0; i < droppedItems[index].length; i++) {
                  const d = droppedItems[index][i]
                  const isInRightPlace = Options[index].Answers.findIndex(
                    (answer) => answer.Key === d.Key
                  )
                  if (isInRightPlace === -1) {
                    isAligned = false
                    break
                  }
                }
              } else {
                isAligned = false
              }
            }
            return (
              <div
                className={
                  Options.length - 1 === index ? 'categ-bin-last' : 'categ-bin'
                }
                id={index.toString()}
                key={index.toString()}
                style={{
                  borderWidth:
                    dragItems.length === 0 || completed === 1 || !isActive
                      ? '2px'
                      : '0px',
                  borderColor:
                    droppedItems[index] && droppedItems[index].length > 0
                      ? isAligned
                        ? '#0bff31'
                        : 'red'
                      : 'red',
                  borderStyle:
                    isPractice || completed === 1 || !isActive
                      ? 'solid'
                      : 'none'
                }}
                onDrop={(event) => handleDroppedItems(index, dragItem)}
                onDragOver={(event) => allowDrop(event)}
              >
                <p
                  className='categ-bin-label'
                  style={{
                    fontSize:
                      QuestionFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : QuestionFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                >
                  {option.Question.Value}
                </p>
                <div
                  style={{
                    width: '100%',
                    height: '90%',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '1%',
                    paddingBottom: '1%'
                    //justifyContent: "center",
                  }}
                >
                  {droppedItems[index] &&
                    _.chunk(droppedItems[index], 3).map((ds, i) => {
                      //console.log(ds);
                      return (
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                          }}
                          draggable='false'
                        >
                          {ds.map((items, idx) => {
                            const isInRightPlace = Options[
                              index
                            ].Answers.findIndex(
                              (answer) =>
                                answer.Key === items.Key && !items.IsDecoy
                            )
                            return (
                              <div
                                className='categ-selected-item-container'
                                id={index.toString()}
                                style={{
                                  backgroundColor: AnswerFillColor,
                                  border:
                                    isPractice || completed === 1 || !isActive
                                      ? isInRightPlace >= 0
                                        ? '2px solid #3EC986'
                                        : '2px solid #FF551F'
                                      : '2px solid #B5B5B5',
                                  color: AnswerColorFill,
                                  fontFamily: FontStyle,
                                  fontStyle:
                                    Italic === 'True' ? 'italic' : 'normal',
                                  fontWeight:
                                    Bold === 'True' ? 'bold' : 'normal',
                                  animationName:
                                    isPractice || completed === 1
                                      ? isInRightPlace >= 0
                                        ? 'pulse_animation'
                                        : 'shake_animation'
                                      : 'zoom-in-zoom-out',
                                  animationDuration: '200ms'
                                }}
                                draggable='false'
                                onClick={() => {
                                  let droppedItemsCopy = [...droppedItems]
                                  const temp = droppedItemsCopy[index].filter(
                                    (itm, i) => itm.Key !== items.Key
                                  )
                                  droppedItemsCopy[index] = temp
                                  setDroppedItems(droppedItemsCopy)
                                  let dragItemsCopy = [...dragItems]
                                  dragItemsCopy.push(items)
                                  setdragItems(dragItemsCopy)
                                  validateCorrectAnswer(
                                    droppedItemsCopy,
                                    dragItemsCopy,
                                    currentAttempts,
                                    currentScore,
                                    false
                                  )
                                }}
                              >
                                <RectangleContent
                                  contentType={AnswerType}
                                  contentData={items.Value}
                                />
                              </div>
                            )
                          })}
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}
        >
          {Options.map((option, index) => {
            const modifiedData = Options[index].Answers.filter(
              (a) => !a.IsDecoy
            )
            return (
              <div
                className='card-shadow'
                id={index.toString()}
                key={index.toString()}
                style={{
                  width: '100%',
                  minHeight: '100%',
                  backgroundColor: QuestionFillColor,
                  margin: '10px',
                  borderRadius: '10px',
                  paddingBottom: '15px',
                  borderWidth: '2px',
                  borderColor: '#0bff31',
                  borderStyle: 'solid'
                }}
              >
                <p
                  style={{
                    margin: '5px',
                    fontSize:
                      QuestionFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : QuestionFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    color: QuestionColorFill,
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                >
                  {option.Question.Value}
                </p>
                <div
                  className='row'
                  style={{
                    width: 'fit-content',
                    margin: 'auto',
                    justifyContent: 'center'
                  }}
                >
                  {modifiedData &&
                    modifiedData.map((items, i) => {
                      return (
                        <div
                          style={{
                            display: 'inline-flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap'
                          }}
                        >
                          <div
                            className='card-shadow'
                            style={{
                              backgroundColor: AnswerFillColor,
                              margin: '5px 5px 5px 5px',
                              width:
                                AnswerType === 'text' ? '130px' : 'fit-content',
                              cursor: 'pointer',
                              borderWidth: '3px',
                              borderColor: '#0bff31',
                              borderStyle: 'solid',
                              textAlign: 'center',
                              color: AnswerColorFill,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              borderRadius: '5px',
                              padding: '5px'
                            }}
                          >
                            {AnswerType === 'text' ? (
                              items.Value
                            ) : AnswerType === 'inktotext' ? (
                              <span
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  margin: '0px',
                                  overflowWrap: 'anywhere'
                                }}
                              >
                                <InlineMath>{items.Value}</InlineMath>
                              </span>
                            ) : (
                              <img
                                src={items.Value}
                                style={{
                                  width: '70px',
                                  height: '70px',
                                  objectFit: 'contain'
                                }}
                                alt='image'
                              />
                            )}
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div
        id='item-container'
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: '100%',
          alignSelf: 'center',
          paddingTop: '1%'
        }}
      >
        {!isVerifyMode &&
          dragItems &&
          _.chunk(dragItems, screenMode === 'phone' ? 4 : 7).map((ds, i) => {
            return (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                {ds.map((items, idx) => {
                  return (
                    <div
                      className='rectangle-card-caontainer'
                      style={{
                        backgroundColor: AnswerFillColor,
                        fontSize:
                          screenMode === 'phone' && AnswerType === 'inktotext'
                            ? ''
                            : AnswerFontSize === 'SMALL'
                            ? SMALL_DESKTOP
                            : AnswerFontSize === 'LARGE'
                            ? LARGE_DESKTOP
                            : MEDIUM_DESKTOP,
                        color: AnswerColorFill
                      }}
                      draggable='true'
                      onDragStart={() => onDragging(items)}
                    >
                      <RectangleContent
                        contentType={AnswerType}
                        contentData={items.Value}
                      />
                    </div>
                  )
                })}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default CategorizeComponent
